import UpgradePopUpPage from "./UpgradePopUpPage";

const routes = [
  {
    path: "/upgrade-popup",
    name: "upgrade-popup",
    component: UpgradePopUpPage,
  }
];

export default routes;
